import * as React from 'react';
import { Header } from './Header';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { Footer } from './Footer';
import { inject, observer } from 'mobx-react';
import { STORE_AUTH, STORE_COMMON } from '../constants';
import { AuthStore, CommonStore } from '../stores';
import { Overlay } from '../common/Overlay';
import { NotificationSystem } from '../common/UI/NotificationSystem'
import { PrintForm } from './PrintForm';




type LayoutProps = RouteComponentProps<any>;

@inject(STORE_AUTH, STORE_COMMON)
@observer
class Layout extends React.Component<LayoutProps, any> {

    commonStore = (this.props as any)[STORE_COMMON] as CommonStore;
    authStore = (this.props as any)[STORE_AUTH] as AuthStore;


    private checkAuth() {


        if (!this.authStore.isAuthenticated && (this.props.location.pathname.startsWith("/login") || this.props.location.pathname.startsWith("/register")))
            return this.props.children; //show login


        if (!this.authStore.isAuthenticated && !(this.props.location.pathname.startsWith("/login") || this.props.location.pathname.startsWith("/register"))) {

            return <Redirect to={`/login?from=${encodeURIComponent(this.props.location.pathname)}`} />; //show login
        }

        if (this.authStore.isAuthenticated && (this.props.location.pathname.startsWith("/login") || this.props.location.pathname.startsWith("/register"))) {
            const url = this.props.location.search.length > 1 ? decodeURIComponent(this.props.location.search.replace("?from=", "")) : "/";
            return <Redirect to={url} />; //show login 
        }



        return <div>
            <br />
            {this.props.children}
        </div>
    }

    public render() {


        return [<div id="appContainer" key={1}>

            {this.commonStore.overlayIsVisible ? <Overlay message={this.commonStore.overlayMessage} /> : []}
            <Header logout={() => { this.authStore.logout() }} />
            <div style={{ marginTop: '50px', marginBottom: "20px" }} className="container-fluid">
                {this.checkAuth()}
            </div>
            {/* <Notifications notifications={this.props.notifications} /> */}
            <Footer commonStore={this.commonStore} />
            {/* <DevTools /> */}
            <NotificationSystem />
        </div>,
        <div id="printContainer" key={2}>
            <PrintForm />
        </div>];
    }
}


export const LayoutContainer = withRouter(Layout);
